import { LeftSidebar } from '../LeftSidebar';
import { ThemeProvider } from '../ThemeContext';
import { LayoutProvider, useLayout } from '../LayoutContext';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const MainContent = ({ children }: { children: React.ReactNode }) => {
  const mapViewPageLayout = useLocation().pathname.includes('mapView');
  const { hasRightSidebar, contentPadding } = useLayout();
  const contentClasses = `relative flex flex-col gap-6 ${mapViewPageLayout ? 'h-full' : 'min-h-full'} content-with-padding ${
    hasRightSidebar
      ? 'p-6 pl-52 ml-6'
      : mapViewPageLayout
        ? 'p-0 ml-0'
        : 'p-6 pl-10'
  }`;

  return (
    <main
      className="flex-1 overflow-y-auto overflow-x-hidden transition-colors duration-200 custom-scrollbar"
      style={{
        ['--content-pad' as any]: contentPadding,
        backgroundColor: '#f9fafb',
      }}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={contentClasses}
        style={{ backgroundColor: '#f9fafb' }}>
        {children}
      </motion.div>
    </main>
  );
};

// ThemedToasts is now at app root

const LayoutContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className="flex h-screen overflow-y-hidden transition-colors duration-200"
      style={{ backgroundColor: '#f9fafb' }}>
      <LeftSidebar />
      <MainContent>{children}</MainContent>
    </div>
  );
};

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeProvider>
      <LayoutProvider>
        <LayoutContent>{children}</LayoutContent>
      </LayoutProvider>
    </ThemeProvider>
  );
};
